<template>
  <div class="container" multiline>
    <b-field horizontal :label="$translate('street') | capitalize">
      <b-input
        :value="address.street"
        @input="address.street = $event"
      ></b-input>
    </b-field>
    <b-field horizontal :label="$translate('hamlet') | capitalize">
      <b-input
        :value="address.cityArea"
        @input="address.cityArea = $event"
      ></b-input>
    </b-field>
    <b-field horizontal :label="$translate('city') | capitalize">
      <b-input :value="address.city" @input="address.city = $event"></b-input>
    </b-field>
    <b-field horizontal :label="$translate('county') | capitalize">
      <b-input
        :value="address.county"
        @input="address.county = $event"
      ></b-input>
    </b-field>
    <b-field horizontal :label="$translate('postal_code') | capitalize">
      <b-input
        :value="address.postalCode"
        @input="address.postalCode = $event"
      ></b-input>
    </b-field>
    <b-field horizontal :label="$translate('country') | capitalize">
      <b-select
        :placeholder="$translate('placeholder_country')"
        :value="address.country"
        @input="address.country = $event"
      >
        <option
          v-for="option in countries"
          :value="option['code']"
          :key="option['code']"
          >{{ $translate(option["code"]) }}</option
        >
      </b-select>
    </b-field>
  </div>
</template>

<script>
export default {
  name: "addressForm",
  props: ["address"],
  data() {
    return {
      countries: []
    };
  },
  methods: {
    loadCountries() {
      this.$db
        .collection("countries")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            var country = doc.data();
            country.id = doc.id;
            this.countries.push(country);
          });
        });
    }
  },
  mounted() {
    this.loadCountries();
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin-bottom: 20px;
}
</style>
